export const API_BASE = process.env.REACT_APP_API_URL || '';

export const ROUTES = {
  recent:  process.env.REACT_APP_RECENT_PATH  || '/api/Donation/recent',
  biggest: process.env.REACT_APP_BIGGEST_PATH || '/api/Donation/biggest',
  total:   process.env.REACT_APP_TOTAL_PATH   || '/api/Donation/total',
};

export function withBase(path) {
  return `${API_BASE}${path.startsWith('/') ? '' : '/'}${path}`;
}
